import React from 'react';

export interface StepperCircleProps extends React.HTMLAttributes<HTMLDivElement> {}

function StepperCircle({ children, className = '', ...props }: StepperCircleProps): JSX.Element {
  return (
    <div className={`stepper-circle ${className}`} {...props}>
      {children}
    </div>
  );
}

export default StepperCircle;
